export default "__VITE_ASSET__2994888c__"